module.exports = __webpack_public_path__ + "img/output_5.b11a84da.png";